var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":"/shopinfo"}},[_c('h3',{staticClass:"big-title"},[_vm._v("返回 信息发布>>"+_vm._s(_vm.m.title))])]),_c('pre',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.m.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }